export class PucaCitizenInformationModel {
	CountryOfCitizenship: string = '';
	OtherCountryOfCitizenship: string = '';
	IsUSCitizen: string = "0";
	USCitizenshipStatus: string = "0";
	AlienRegistrationNumber?: string = '';
	VisaType: string = '';
	HasUSVisa: string = "0";
	VisaCategory: string = '';
	AlienRegNumber: string = '';
}
